// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__VBB44","new-course":"Dashboard_new-course__8BblF","form":"Dashboard_form__659lj","sort":"Dashboard_sort__xGIRI"};